<template>
  <div>
    <div>
      <div id="reseller-assignment">
        <v-row justify="center">
          <v-card
            rounded="xl"
            flat
            width="520px"
            min-height="720px"
            class="card"
            data-aos="fade-up"
            :class="[MIXIN_SETUP_UI.show ? 'ma-10' : 'ma-5']"
          >
            <v-form ref="assignmentForm">
              <v-col cols="12">
                <v-text-field
                  label="First Name*"
                  type="text"
                  ref="firstName"
                  v-model="firstName"
                  :rules="[() => !!firstName || 'This field is required']"
                  :error-messages="errorMessages"
                ></v-text-field>

                <v-text-field
                  label="Middle Name*"
                  type="text"
                  ref="middleName"
                  v-model="middleName"
                  :rules="[() => !!middleName || 'This field is required']"
                  :error-messages="errorMessages"
                ></v-text-field>

                <v-text-field
                  label="Last Name*"
                  type="text"
                  ref="lastName"
                  v-model="lastName"
                  :rules="[() => !!lastName || 'This field is required']"
                  :error-messages="errorMessages"
                ></v-text-field>

                <v-menu
                  v-model="birthdateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      placeholder="M/D/YYYY"
                      :rules="[() => !!birthdate || 'This field is required']"
                      v-model="birthdateFormat"
                      label="Birthday*"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="birthdate"
                    ref="birthdate"
                    :error-messages="errorMessages"
                    no-title
                    @input="birthdateMenu = false"
                  ></v-date-picker>
                </v-menu>

                <v-text-field
                  label="Email Address*"
                  type="text"
                  ref="emailAddress"
                  v-model="emailAddress"
                  :rules="[
                    () => !!emailAddress || 'This field is required',
                    () =>
                      /.+@.+\..+/.test(emailAddress) || 'Email must be valid',
                  ]"
                  :error-messages="errorMessages"
                ></v-text-field>

                <v-text-field
                  label="Contact Number*"
                  type="text"
                  ref="contactNumber"
                  v-model="contactNumber"
                  :rules="[() => !!contactNumber || 'This field is required']"
                  :error-messages="errorMessages"
                ></v-text-field>

                <v-text-field
                  label="Access Key*"
                  ref="accessKey"
                  v-model="accessKey"
                  :rules="[() => !!accessKey || 'This field is required']"
                  :error-messages="errorMessages"
                  :append-icon="showKey ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showKey ? 'text' : 'password'"
                  @click:append="showKey = !showKey"
                ></v-text-field>

                <v-text-field
                  label="Activation Code*"
                  ref="activationCode"
                  v-model="activationCode"
                  :rules="[() => !!activationCode || 'This field is required']"
                  :error-messages="errorMessages"
                  :append-icon="showCode ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showCode ? 'text' : 'password'"
                  @click:append="showCode = !showCode"
                ></v-text-field>

                <div class="text-center mt-5">
                  <base-button
                    name="Send"
                    color="#0e6ccd"
                    x-large
                    min-width="50%"
                    @click="confirmAssignmentInfo()"
                  ></base-button>
                </div>
              </v-col>
            </v-form>
          </v-card>
        </v-row>
      </div>
    </div>

    <base-confirm-dialog
      v-model="confirmDialog"
      title="Confirm"
      message="Would you like to send a key assignment request?"
      @do="saveAssignmentInfo()"
    ></base-confirm-dialog>

    <base-success-dialog
      v-model="successDialog"
      title="Thank you!"
      message="You have successfully activated your account. You may now call us anytime for any health concerns."
    ></base-success-dialog>

    <base-error-dialog
      v-model="errorDialog.show"
      :title="errorDialog.title"
      :message="errorDialog.message"
    ></base-error-dialog>
  </div>
</template>

<script>
import Repository from "@/api/repositories";
const KeyAssignmentApi = Repository.get("keyAssignments");

export default {
  data() {
    return {
      /* form fields */
      firstName: null,
      middleName: null,
      lastName: null,
      birthdate: null,
      emailAddress: null,
      contactNumber: null,
      accessKey: null,
      activationCode: null,
      /* form fields */
      birthdateMenu: false,
      birthdateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      errorMessages: '',
      confirmDialog: false,
      successDialog: false,
      showCode: false,
      showKey: false,
      errorDialog: {
        show: false,
        title: null,
        message: null
      }
    }
  },
  watch: {
    birthdate(val) {
      this.birthdateFormatted = this.formatDate(val)
    },
  },
  computed: {
    birthdateFormat () {
      return this.formatDate(this.birthdate)
    },
    assignmentForm() {
      return {
        firstName: this.firstName,
        middleName: this.middleName,
        lastName: this.lastName,
        birthdate: this.birthdate,
        emailAddress: this.emailAddress,
        contactNumber: this.contactNumber,
        accessKey: this.accessKey,
        activationCode: this.activationCode,
      }
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    confirmAssignmentInfo() {
      if (this.$refs.assignmentForm.validate()) this.confirmDialog = true;
		},
		saveAssignmentInfo() {
      let form = {
        'first_name': this.firstName,
        'middle_name': this.middleName,
        'last_name': this.lastName,
        'birthdate': this.birthdate,
        'email': this.emailAddress,
        'phone_number': this.contactNumber,
        'access_key': this.accessKey,
        'activation_code': this.activationCode,
      };
      
      KeyAssignmentApi.create(form)
        .then(response => {
          console.log({ response });

          if (response) {
            this.confirmDialog = false;
            this.successDialog = true;
          }
        })
        .catch(error => {
          console.log({ error });
          this.errorDialog = {
            show: true,
            title: "Failed key assignment",
            message: error.response.data.message
          };
        });
    }
  }
}
</script>

<style scoped lang="scss">
#reseller-assignment {
  .card {
    padding: 5%;
  }
}
</style>